import createStore from './Utilities/createStore'
import { reducers } from '../Config'

export const { store, persistor, history } = createStore(reducers)
